import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AppHeader from "@/components/AppHeader";

export const COPY = {
  en: {
    eyebrow: "Free Limited Trial",
    title: "Your free practice interview is complete",
    body: "You have completed your 6-question Free Limited Trial. This trial lets you experience the Interview Simulator before signing up for a paid account.",
    noResults: "Your Free Limited Trial includes feedback for Question 1. The full interview report, downloads, re-practice, and restart are available with a paid account.",
    future: "A paid account unlocks the complete interview report and coaching features.",
    back: "Return to account home",
  },
  "pt-BR": {
    eyebrow: "Teste Gratuito Limitado",
    title: "Sua entrevista gratuita foi concluída",
    body: "Você concluiu seu Teste Gratuito Limitado de 6 perguntas. Este teste permite experimentar o Interview Simulator antes de assinar uma conta paga.",
    noResults: "Seu Teste Gratuito Limitado inclui o feedback da Pergunta 1. O relatório completo, downloads, nova prática e reinício estão disponíveis com uma conta paga.",
    future: "Uma conta paga libera o relatório completo da entrevista e os recursos de coaching.",
    back: "Voltar à página inicial da conta",
  },
  "es-419": {
    eyebrow: "Prueba Gratuita Limitada",
    title: "Su entrevista gratuita ha finalizado",
    body: "Ha completado su Prueba Gratuita Limitada de 6 preguntas. Esta prueba le permite experimentar Interview Simulator antes de registrarse para una cuenta de pago.",
    noResults: "Su Prueba Gratuita Limitada incluye los comentarios de la Pregunta 1. El informe completo, las descargas, la repetición y el reinicio están disponibles con una cuenta de pago.",
    future: "Una cuenta de pago desbloquea el informe completo de la entrevista y las funciones de coaching.",
    back: "Volver a la página principal de la cuenta",
  },
  "fr-CA": {
    eyebrow: "Essai Gratuit Limité",
    title: "Votre entrevue gratuite est terminée",
    body: "Vous avez terminé votre Essai Gratuit Limité de 6 questions. Cet essai vous permet de découvrir Interview Simulator avant de vous inscrire à un compte payant.",
    noResults: "Votre Essai Gratuit Limité comprend la rétroaction pour la Question 1. Le rapport complet, les téléchargements, la nouvelle pratique et le redémarrage sont disponibles avec un compte payant.",
    future: "Un compte payant donne accès au rapport complet de l'entrevue et aux fonctions de coaching.",
    back: "Retourner à l'accueil du compte",
  },
};

export default function FreeComplete() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const t = COPY[user?.preferred_language || "en"] || COPY.en;

  return (
    <div className="min-h-screen w-full bg-[color:var(--bg-base)]" data-testid="free-complete-screen">
      <AppHeader />

      <main className="max-w-2xl mx-auto p-6 md:p-10">
        <section className="rounded-3xl border border-[color:var(--border-stone)] bg-white p-7 sm:p-10 shadow-sm">
          <div className="text-xs uppercase tracking-[0.2em] text-[color:var(--brand)]">{t.eyebrow}</div>
          <h1 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight text-[color:var(--text-primary)]">{t.title}</h1>
          <p className="mt-5 text-sm sm:text-base leading-relaxed text-[color:var(--text-secondary)]">{t.body}</p>
          <div className="mt-6 rounded-2xl border border-[color:var(--border-stone)] bg-[color:var(--bg-surface-hover)] p-4">
            <p className="text-sm leading-relaxed text-[color:var(--text-primary)]">{t.noResults}</p>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-[color:var(--text-secondary)]">{t.future}</p>
          <button
            type="button"
            onClick={() => navigate("/", { replace: true })}
            className="mt-7 rounded-full bg-[color:var(--brand)] hover:bg-[color:var(--brand-hover)] text-white px-6 py-3 text-sm font-medium"
            data-testid="free-complete-home"
          >
            {t.back}
          </button>
        </section>
      </main>
    </div>
  );
}
